import './datasift_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.FacebookContentView extends Monitoring.Views.SocialContents.DatasiftContentView
  tagName: "section"
  className: "content tweet" # facebook?
  template: JST["backbone/templates/monitoring/social_contents/facebook"]
